import { render, staticRenderFns } from "./SingleCancelModal.vue?vue&type=template&id=80327c40&"
import script from "./SingleCancelModal.vue?vue&type=script&lang=js&"
export * from "./SingleCancelModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports